import { Control, FormDefinition, Question } from "interfaces/Phoenix.FormsDesigner.Models";

// taken from old code
export const createSelectGroupEnumItemId = (selectGroupBindableId: string, enumItemName: string) => {
  let sysName = enumItemName.toLowerCase().replace(/\W/g, ' ').trim().replace(/\s+/g, '_').replace(/_+/g, '_');
  return selectGroupBindableId + "_" + sysName;
};

export const isQuestionSelectGroup = (question: Question) => question.control.type === "SelectGroup" && question.control.dataField?.type === "Token";

// this was used for the old desginer, apparently we dont care about this anymore
export const getControlTypeText = (question: Question) => `${question.control.type}-${question.control.appearance || "full"}` + (question.control.dataField ? `-${question.control.dataField.type || "String"}` : '');

export const deepCopy = <T,>(object: T) => JSON.parse(JSON.stringify(object)) as T;

export const getIdFromQuestion = (question: Question, formDef: FormDefinition) => {
  if (!question.control.label) question.control.label = "null";

  let base = question.control.label.toLowerCase().replace(/\W/g, " ").trim().replace(/\s+/g, "_").replace(/_+/g, "_");
  let ret = base;
  let n = 1;

  while (doesBindableIdExist(question, ret, formDef)) ret = base + "_" + (n ++);

  return ret;
};

export const doesBindableIdExist = (question: Question, bindableId: string, formDef: FormDefinition) =>
  formDef.questionLibrary.questions.some(q => q.control.dataField?.bindableId === bindableId && q.id !== question.id);

const trueRequiredExpression = "true()";

// Check if the required checkbox should be set based on the expression
export const isRequiredCheckboxChecked = (requiredExpression: unknown): boolean => requiredExpression === trueRequiredExpression;

// get the fields for a required checkbox change
export const getRequiredFieldsForToggle = (control: Control, isChecked: boolean): { requiredExpression: string; requiredMessage: string } => {
  if (!isChecked) {
    return { requiredExpression: "", requiredMessage: "" };
  }
  const base = (control.label ?? "").replace(/'/g, "");
  const suffix = control.type === "Photo" ? " is a required photo." : " is a required field.";
  return {
    requiredExpression: trueRequiredExpression,
    requiredMessage: base + suffix,
  };
};
